import { Link } from "react-router";
import type { AriaAttributes, ReactNode } from "react";
import styles from "./GnbButton.module.css";

type GnbButtonProps = {
  children: ReactNode;
  className?: string;
  current?: boolean;
  disabled?: boolean;
  to?: string;
  "aria-label"?: AriaAttributes["aria-label"];
};

export function GnbButton({
  children,
  className,
  current = false,
  disabled = false,
  to,
  "aria-label": ariaLabel,
}: GnbButtonProps) {
  const ariaCurrent = current ? "page" : undefined;
  const classNames = [styles.item, className ?? ""].filter(Boolean).join(" ");

  if (to) {
    return (
      <Link className={classNames} to={to} aria-current={ariaCurrent} aria-label={ariaLabel}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={classNames}
      type="button"
      disabled={disabled}
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}
